import { AccessLoading } from "@acdc2/ui/components/access-loading";
import { useTranslation } from "react-i18next";
import { Scaffold } from "../shell/Scaffold";
import { Navbar } from "../shell/Navbar";

export function LoadingScreen() {
  const { t } = useTranslation();

  return (
    <Scaffold navbar={<Navbar />}>
      <div className="flex-1 flex flex-col justify-center items-center gap-4">
        <AccessLoading />
        <span className="text-lg font-bold uppercase">
          {t("LoadingScreen.label")}
        </span>
      </div>
    </Scaffold>
  );
}
